<app-message [service]="messageService"></app-message>

<div class="modal-header">
  <h5 class="modal-title" i18n="@@ChargingParkSubscribeHeader">Rechnungsadresse und Zahlungsmethode</h5>
  <button type="button" id="x_close" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="onCancelClick()"></button>
</div>

<div class="modal-body p-0">
  <div class="overview" *ngIf="formCreated && this.subscriptionFormService">
    <p i18n="@@YourPricingInThisPark">Ihr Tarif in diesem Ladepark:</p>
    <h2 i18n="@@PricingName" class="m-0"><strong>{{ this.pricing.name }}</strong></h2>
    <p class="price mb-0" i18n="@@CurrencyUnit"><strong>{{ pricing.price | currency:'EUR' }}</strong> pro kWh - AC</p>
    <p class="price" i18n="@@CurrencyUnit"><strong>{{ pricing.priceDc | currency:'EUR' }}</strong> pro kWh - DC</p>
    <p i18n="@@PricingDescription" *ngIf="this.pricing.description">{{ this.pricing.description }}</p>
    <p i18n="@@ChargingParkPricingMessage">Die Abrechnung erfolgt monatlich basierend auf Ihrer tatsächlichen Nutzung, wobei die Berechnung in Wh erfolgt [1 kWh entspricht 1000 Wh].
    <p i18n="@@ReadPaymentProcessConditions">Bitte beachten Sie, dass wir für die Zahlungsabwicklung Stripe als unseren Zahlungsdienstleister nutzen. Wir bitten Sie, unsere Allgemeinen Geschäftsbedingungen (AGB) als auch die AGB von Stripe sorgfältig zu lesen.</p>

    <p i18n="@@ReadCubosConditions">Nachfolgend können Sie unsere AGB und Datenschutzrichtlinien einsehen und herunterladen.</p>
    <p class="d-flex gap-2">
      <a href="https://assets-global.website-files.com/63d9fc1e4a5c00a5ee5b1f3f/63e24d8ae16849e8e26e42a5_cubos_agb.pdf">
        <small>Allgemeine Geschäftsbedingungen</small>
      </a>
      <a href="https://www.cubos.com/datenschutz">
        <small>Datenschutzrichtlinien</small>
      </a>
    </p>

    <p>Die folgenden Links führen Sie zu den AGB von Stripe. Für die Richtigkeit und den Inhalt ist ausschließlich Stripe verantwortlich.</p>

    <p class="d-flex gap-2">
      <small><a href="https://stripe.com/checkout/terms" id="terms" target="_blank" i18n="@@StripeTermsButton">Bedingungen</a></small>
      <small><a href="https://stripe.com/privacy" id="privacy" target="_blank" i18n="@@StripePrivacyButton">Datenschutz</a></small>
      <small *ngIf="this.subscriptionFormService.form.value.method == 'sepa'">
        <a href="https://stripe.com/de/legal/sepa-direct-debit" id="SEPA" target="_blank" i18n="@@StripeSEPAButton">SEPA-Lastschrift</a>
      </small>
    </p>

    <label for="agreed" class="ml-4">
      <p>
        <input type="checkbox" class="form-check-input ng-untouched ng-pristine ng-valid" id="agreed" [(ngModel)]="agreed">
        Durch das Ankreuzen dieses Kästchens bestätigen Sie, dass Sie unsere AGB gelesen haben und diesen zustimmen. Zudem erkennen Sie sich einverstanden, dass die Zahlungsabwicklung über Stripe erfolgt.
      </p>
    </label>

    <p *ngIf="this.subscriptionFormService.form.value.method == 'card'" i18n="@@FutureCardPayConcentMessage">
      <small>
        Mit der Bestätigung Ihres Abonnements erklären Sie sich damit einverstanden, dass CUBOS Service GmbH Ihre Karte für zukünftige Zahlungen gemäß der Nutzungsbedingungen belastet.
      </small>
    </p>
    <p *ngIf="this.subscriptionFormService.form.value.method == 'sepa'" i18n="@@FutureSEPAPayConcentMessage">
      <small>
        Durch Angabe der IBAN und Bestätigung der Zahlung<br />(A) ermächtige ich/ermächtigen wir CUBOS Service GmbH und Stripe, unseren Zahlungsdienstleister, und/oder PPRO, den lokalen Zahlungsdienstleister von Stripe, Zahlungen von meinem/unserem Konto mittels Lastschrift einzuziehen.<br />(B) Zugleich weise ich mein/weisen wir unser Kreditinstitut gemäß diesen Anweisungen an, die auf mein/unser Konto gezogenen Lastschriften einzulösen. Hinweis: Ich kann/Wir können innerhalb von acht Wochen, beginnend mit dem Belastungsdatum, die Erstattung des belasteten Betrages verlangen. Es gelten dabei die mit meinem/unserem Kreditinstitut vereinbarten Bedingungen.
      </small>
    </p>
  </div>

  <form [formGroup]="this.subscriptionFormService.form" (ngSubmit)="onSubmit(this.subscriptionFormService.form.value)" *ngIf="formCreated && this.subscriptionFormService && subscription == null">
    <div class="form-group mb-2">
      <label for="email" class="form-label" i18n="@@EmailLabel">E-Mail*</label>
      <input type="text" class="form-control" formControlName="email" id="subscription-email" i18n-placeholder="@@EmailPlaceholder" placeholder="E-Mail*" ngbAutoFocus />

      <div class="error">
        <em *ngIf="this.subscriptionFormService.validateControl('email') && this.subscriptionFormService.hasError('email', 'required')" i18n="@@LastnameRequiredErrorMessage">Nachname wird benötigt</em>
        <em *ngIf="this.subscriptionFormService.validateControl('email') && this.subscriptionFormService.hasError('email', 'pattern')" i18n="@@UnvalidInputErrorMessage">Falsche Eingabe</em>
      </div>
    </div>

    <h6 i18n="@@InvoiceAdressHeader">Rechnungsaddresse*</h6>
    <div class="form-group address-data">
      <input type="text" class="form-control" formControlName="company" id="subscription-company" placeholder="Firma" i18n-placeholder="@@CompanyPlaceholder"/>
      <input type="text" class="form-control" formControlName="name" id="subscription-name" placeholder="Name*" i18n-placeholder="@@NamePlaceholder"/>
      <input type="text" class="form-control" formControlName="line1" id="subscription-adress-line1" placeholder="Straße und Hausnummer*" i18n-placeholder="@@AdressLine1Placeholder" />
      <input type="text" class="form-control" formControlName="line2" id="subscription-adress-line2" placeholder="Addresszusatz" i18n-placeholder="@@AdressLine2Placeholder" />
      <input type="text" class="form-control" formControlName="postalCode" id="subscription-postalCode" placeholder="PLZ*" i18n-placeholder="@@postalCodePlaceholder"/>
      <input type="text" class="form-control" formControlName="city" id="subscription-city" placeholder="Stadt*" i18n-placeholder="@@CityPlaceholder"/>

      <div class="error" style="grid-column: span 3;">
        <em *ngIf="this.subscriptionFormService.validateControl('name') && this.subscriptionFormService.hasError('name', 'required')" i18n="@@NameRequiredErrorMessage">Name wird benötigt<br /></em>
        <em *ngIf="this.subscriptionFormService.validateControl('line1') && this.subscriptionFormService.hasError('line1', 'required')" i18n="@@StreetRequiredErrorMessage">Straße und Hausnummer werden benötigt<br /></em>
        <em *ngIf="this.subscriptionFormService.validateControl('postalCode') && this.subscriptionFormService.hasError('postalCode', 'required')" i18n="@@postalCodeRequiredErrorMessage">PLZ wird benötigt<br /></em>
        <em *ngIf="this.subscriptionFormService.validateControl('city') && this.subscriptionFormService.hasError('city', 'required')" i18n="@@CityRequiredErrorMessage">Stadt wird benötigt</em>
      </div>
    </div>

    <p i18n="@@MandatoryInfo" style="margin: 0;"><small>* Pflichtangaben</small></p>
  </form>

  <form method="post" id="payment-form" [style]="subscription == null ? 'opacity: 0; max-height: 0px; overflow: hidden;' : ''">
    <div id="payment-element">
      <div id="card-element"></div>
      <div id="error-message"></div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button type="button" id="cancel" class="btn btn-yellow me-1" data-bs-dismiss="modal"
    [routerLink]="['/profile']" (click)="onCancelClick()" i18n="@@CloseButton">Schließen</button>

  <form [formGroup]="this.subscriptionFormService.form" (ngSubmit)="onSubmit(this.subscriptionFormService.form.value)" *ngIf="formCreated && (subscription == null)">
    <button type="submit" id="abo_confirm" class="btn btn-yellow" [disabled]="!agreed || !this.subscriptionFormService.form.valid">
      Weiter zur Zahlungsmethode
    </button>
  </form>

  <form method="post" id="payment-form" (ngSubmit)="onStripeSubmit()" [style]="subscription == null ? 'opacity: 0; max-height: 0px; overflow: hidden;' : ''">
    <button *ngIf="formCreated && isCreatingStripeForm && subscription != null" type="submit" class="btn btn-yellow">
      Zahlungsmethode speichern
    </button>
  </form>
</div>
